import React, { createContext, useContext, useState } from 'react';

const LoaderContext = createContext(null);

const useLoader = () => {
  const loaderContext = useContext(LoaderContext);
  if (typeof loaderContext === 'undefined') {
    throw new Error('useLoader must be used within a LoaderProvider');
  }
  return loaderContext;
};

function LoaderProvider({ children }) {
  const [toggleLoader, setToggleLoader] = useState(false);

  const safeToggleLoader = show => {
    if (show) {
      setToggleLoader(false);
    }
    setToggleLoader(show);
  };

  return (
    <LoaderContext.Provider
      value={{
        toggleLoader,
        setToggleLoader: safeToggleLoader
      }}
    >
      {children}
    </LoaderContext.Provider>
  );
}

export { useLoader, LoaderProvider };
